
@if (isLoading | async) {
  <div class="overlay"><div class="text-center h-100 d-flex"><div class="spinner-border m-auto" style="height: 3rem; width: 3rem;" >
    <span class="sr-only">Loading </span>
  </div>
</div>
</div>
}

